import {ratioToPercentage} from '#/utils/ratio-percentage';
import {minReceivedDefaultRatio, minReceivedMaxRatio, minReceivedMinRatio} from '@shareland/shareland-common';

const getMaxSlippagePercentage = (ratio: number): number => Math.round(ratioToPercentage(ratio, true));

export const maxSlippageMinPercentage = getMaxSlippagePercentage(minReceivedMaxRatio);
export const maxSlippageDefaultPercentage = getMaxSlippagePercentage(minReceivedDefaultRatio);
export const maxSlippageMaxPercentage = getMaxSlippagePercentage(minReceivedMinRatio);
